// extracted by mini-css-extract-plugin
export default {"right-addon":"right-addon__t5lQz"};